import { readableTextColor } from "@core/lib/templateContrast";

export interface PollTemplate {
  id: string;
  name: string;
  primary_color: string;
  secondary_color: string;
  logo_url: string | null;
}

interface PollTemplateHeaderProps {
  template: PollTemplate;
  title: string;
}

/**
 * Bannière de branding appliquée sur la page de vote/résultats d'un
 * sondage lorsqu'un template est assigné (task.md Story 1). Réutilisée
 * telle quelle par Vote.tsx et Results.tsx.
 */
export function PollTemplateHeader({
  template,
  title,
}: PollTemplateHeaderProps) {
  const textColor = readableTextColor(template.primary_color);

  return (
    <div
      data-testid="poll-template-header"
      className="flex items-center gap-3 px-6 py-4"
      style={{
        backgroundImage: `linear-gradient(135deg, ${template.primary_color} 0%, ${template.secondary_color} 100%)`,
        color: textColor,
      }}
    >
      {template.logo_url && (
        <img
          src={template.logo_url}
          alt={template.name}
          className="h-8 w-auto max-w-[120px] object-contain"
        />
      )}
      <h1 className="text-lg font-semibold truncate">{title}</h1>
    </div>
  );
}
